import React from 'react';
import { Link } from 'react-router-dom';

/**
 * NotFoundPage component for 404 errors
 * @returns {React.ReactElement} NotFoundPage component
 */
const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center">
        <div>
          <h2 className="text-6xl font-extrabold text-indigo-600">404</h2>
          <h1 className="mt-4 text-3xl font-bold text-gray-900 sm:text-4xl">
            页面未找到
          </h1>
          <p className="mt-6 text-base text-gray-500">
            很抱歉，您访问的页面不存在或已被移除。
          </p>
          <div className="mt-10">
            <Link
              to="/"
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              <svg 
                className="mr-2 -ml-1 w-4 h-4" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M10 19l-7-7m0 0l7-7m-7 7h18" 
                />
              </svg>
              返回首页
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;